module.exports = __webpack_public_path__ + "images/rovo_collection_4.a104ebc14b885f3c5b9054ddc2380433.png";